<template>
  <div class="slogan-container">
    <h1 class="slogan">SK's Journey with Challenge,<br />Passion and Integrity</h1>
    <h3 class="sub-slogan">{{ subSloganText }}</h3>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Slogan',
  computed: {
    ...mapState('report_list', ['lang']),
    subSloganText() {
      return this.lang === 'ENG'
        ? '2025 SK Inc. Sustainability Report'
        : '2025 SK주식회사 지속가능경영보고서';
    }
  }
};
</script>

<style scoped>
@keyframes slideUpAndFadeIn {
  0% {
    opacity: 0.3;
    transform: translateY(30px);
  }
  50%,
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.slogan-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
}

.slogan {
  font-family: Pretendard;
  font-weight: 700;
  font-size: 80px;
  line-height: 120%;
  letter-spacing: 0%;
  color: #ffffff;
  margin-bottom: 1rem;
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.6);
  animation: slideUpAndFadeIn 7s infinite;
}

.sub-slogan {
  font-family: Pretendard;
  font-weight: 600;
  font-size: 24px;
  line-height: auto;
  letter-spacing: -1.5%;
  color: #ffffff;
  margin-bottom: 1rem;
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.6);
}

@media (max-width: 576px) {
  .sub-slogan {
    font-size: 16px;
  }
  .slogan {
    font-size: 32px;
  }
}

@media (min-width: 576px) and (max-width: 1200px) {
  .sub-slogan {
    font-size: calc(16px + (4 * ((100vw - 576px) / (1200 - 576))));
  }
  .slogan {
    font-size: calc(32px + (16 * ((100vw - 576px) / (1200 - 576))));
  }
}

@media (min-width: 1200px) and (max-width: 1920px) {
  .sub-slogan {
    font-size: calc(20px + (12 * ((100vw - 1200px) / (1920 - 1200))));
  }
  .slogan {
    font-size: calc(48px + (32 * ((100vw - 1200px) / (1920 - 1200))));
  }
}

@media (min-width: 1920px) {
  .sub-slogan {
    font-size: 32px;
  }
  .slogan {
    font-size: 80px;
  }
}
</style>
